import type { Block } from '@plentymarkets/shop-api';
import { resolveBlockLayoutRule } from '~/configuration/block-layout.config';

const getFullWidthFromObject = (obj: unknown): boolean | undefined => {
  return getNestedValue<boolean>(obj, ['layout', 'fullWidth'], 'boolean');
};

const hasFullWidth = (block: Block): boolean => {
  const explicit =
    block.type === 'content' ? getFullWidthFromObject(block.content) : getFullWidthFromObject(block.configuration);
  if (explicit !== undefined) return explicit;
  const rule = resolveBlockLayoutRule(block.name);
  return rule.defaultFullWidth;
};

export const useBlockClasses = (block: Block): ComputedRef<Record<string, boolean>> => {
  const { getSetting } = useSiteSettings('horizontalBlockSize');
  const { getSetting: getVerticalSetting } = useSiteSettings('verticalBlockSize');

  return computed(() => {
    const fullWidth = hasFullWidth(block);
    const rule = resolveBlockLayoutRule(block.name);
    const horizontalSpacing = getSetting();
    const verticalSpacing = getVerticalSetting();

    return buildBlockClasses(block, {
      fullWidth,
      rule,
      horizontalSpacing,
      verticalSpacing,
    });
  });
};
